// Vendor
import { useI18n } from 'vue-i18n'

// Components
import HeaderComponent from '../../components/header/index';
import FooterComponent from '../../components/footer/index';
import ImageBoxComponent from '../../components/image-box/index';
import ModalComponent from '../../components/modal/index';
import DataRangeComponent from '../../components/date-range/index';
import ButtonComponent from '../../components/button/index';

export default {
    name: "classifica",
    components: {
        HeaderComponent,
        FooterComponent,
        ImageBoxComponent,
        ModalComponent,
        DataRangeComponent,
        ButtonComponent
    },
    data(){
        return {
            images: [
                {
                    "pid": "314",
                    "imgPath": '2023/314.jpg',
                    "selected": false
                },
                {
                    "pid": "494",
                    "imgPath": '2023/494.jpg',
                    "selected": false
                },
                {
                    "pid": "646",
                    "imgPath": '2023/646.jpg',
                    "selected": false
                },
                {
                    "pid": "1005",
                    "imgPath": '2023/1005.jpg',
                    "selected": false
                },
                {
                    "pid": "1009",
                    "imgPath": '2023/1009.jpg',
                    "selected": false
                },
                {
                    "pid": "1876",
                    "imgPath": '2023/1876.jpg',
                    "selected": false
                },
                {
                    "pid": "1965",
                    "imgPath": '2023/1965.jpg',
                    "selected": false
                },
                {
                    "pid": "2473",
                    "imgPath": '2023/2473.jpg',
                    "selected": false
                },
                {
                    "pid": "2658",
                    "imgPath": '2023/2658.jpg',
                    "selected": false
                },
                {
                    "pid": "4680",
                    "imgPath": '2023/4680.jpg',
                    "selected": false
                },
                {
                    "pid": "4816",
                    "imgPath": '2023/4816.jpg',
                    "selected": false
                },
                {
                    "pid": "4817",
                    "imgPath": '2023/4817.jpg',
                    "selected": false
                },
                {
                    "pid": "5129",
                    "imgPath": '2023/5129.jpg',
                    "selected": false
                },
                {
                    "pid": "5444",
                    "imgPath": '2023/5444.jpg',
                    "selected": false
                },
                {
                    "pid": "5448",
                    "imgPath": '2023/5448.jpg',
                    "selected": false
                },
                {
                    "pid": "5458",
                    "imgPath": '2023/5458.jpg',
                    "selected": false
                },
                {
                    "pid": "5550",
                    "imgPath": '2023/5550.jpg',
                    "selected": false
                },
                {
                    "pid": "5562",
                    "imgPath": '2023/5562.jpg',
                    "selected": false
                },
                {
                    "pid": "5581",
                    "imgPath": '2023/5581.jpg',
                    "selected": false
                },
                {
                    "pid": "5656",
                    "imgPath": '2023/5656.jpg',
                    "selected": false
                }
            ],
            currentPage: 1,
            maxImagesPerPage: 50,
            userLogged: false,
            userPrivacyProfiling: false,
            voted: false,
            pidVoted: '',
            vote_date: '',
            contestActive: false
        }
    },
    setup() {
        const { t } = useI18n({
            inheritLocale: true,
            useScope: 'local'
        })

        return { t }
    },
    computed:{
        /**
         * Filter images by current page and max images per page
         * @returns Array
         */
        paginatedImages() {
            let imagesUnshuffled = this.images;
            const imagesShuffled = imagesUnshuffled
                .map((value) => ({ value, sort: Math.random() }))
                .sort((a, b) => a.sort - b.sort)
                .map(({ value }) => value)
            return imagesShuffled.slice(0, this.currentPage * this.maxImagesPerPage);
        },

        /**
         * Check if there are another images or not
         * @returns {boolean}
         */
        numberTotal(){
            return (this.currentPage * this.maxImagesPerPage) < this.images.length
        }
    },
    methods:{
        // update page and load more images
        loadMore(){
            this.currentPage += 1;
        }
    }
}